import { Location, LocationAW, LocationsSite } from '@/types';
import { Core, LOCATION_AW, LOCATIONS, LOCATIONS_SITES } from '../Core';

class Locations extends Core {
  getLocations = async () => this.get<Location[]>(LOCATIONS());

  updateLocations = async (data: Location) => this.patch(LOCATIONS(), data);

  createLocations = async (data: Location) => this.put(LOCATIONS(), data);

  getLocationsSites = async (inspectionId: number) =>
    this.get<LocationsSite[]>(LOCATIONS_SITES(inspectionId));

  getLocationAW = async (siteId: number) =>
    this.get<LocationAW>(LOCATION_AW(siteId));
}

export const locations = new Locations();
